import React,{ useState, useEffect } from "react";
import Modal from "react-modal";
import { Link } from "react-router-dom";
import { HashLink } from 'react-router-hash-link';
import { Turnstile } from '@marsidev/react-turnstile';

import bg1 from '../../assets/images/bg/C1.webp'
import bg2 from '../../assets/images/bg/C2.webp'
import bg3 from '../../assets/images/bg/C3.webp'
import bg4 from '../../assets/images/bg/C4.webp'
import bg5 from '../../assets/images/bg/C5.webp'
import bg6 from '../../assets/images/bg/C6.webp'
import bg7 from '../../assets/images/bg/C7.webp'
import bg8 from '../../assets/images/bg/C8.webp'
import image1 from "../../assets/images/01.jpg"

// Import insurance logos
import logo1 from '../../assets/images/insurance-logos/1.png'
import logo2 from '../../assets/images/insurance-logos/2.png'
import logo3 from '../../assets/images/insurance-logos/3.png'
import logo4 from '../../assets/images/insurance-logos/4.png'
import logo5 from '../../assets/images/insurance-logos/5.png'
import logo6 from '../../assets/images/insurance-logos/6.png'
import logo7 from '../../assets/images/insurance-logos/7.png'
import logo8 from '../../assets/images/insurance-logos/8.png'
import logo9 from '../../assets/images/insurance-logos/9.png'
import logo10 from '../../assets/images/insurance-logos/10.png'
import logo11 from '../../assets/images/insurance-logos/11.png'

import headshot from '../../assets/images/headshot2.webp'

import NavbarTwo from "../../components/navbar/navbarTwo";

import FooterThree from "../../components/footer/footerThree";
import ScrollTop from "../../components/scrollTop";
import BlogOne from "../../components/blog/blogOne";

import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";

import ModalVideo from 'react-modal-video';
import '../../../node_modules/react-modal-video/css/modal-video.css';

import { FaFacebookF, AiOutlineInstagram, AiFillLinkedin, AiOutlineYoutube } from "../../assets/icons/vander";
import { BsHourglassSplit, BsInfinity, BsHospital, BsHeartPulse, BsBank } from 'react-icons/bs';
import { AiFillBluesky } from "../../assets/icons/BlueskyIcons";
import { FaWheelchair, FaArrowDown } from 'react-icons/fa';

import CountUp from 'react-countup';
import { Parallax } from 'react-parallax';

import Checkmarks from "../../components/checkmarks";
import { scrollWithOffset } from "../../utils/scrollUtils";

import { getFirestore, collection, addDoc, serverTimestamp } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import app from "../../firebase/firebase";

import FloatingTextBubble from "../../components/FloatingTextBubble";



// Set the app element for Modal accessibility
Modal.setAppElement("#root");

export default function IndexBusiness(){
    const [isOpen, setOpen] = useState(false);
    const aboutData = [
        {
            icon:BsHourglassSplit,
            title:'Term Life Insurance'
        },
        {
            icon:BsInfinity,
            title:'Permanent Life Insurance'
        },
        {
            icon:BsHospital,
            icon2:FaWheelchair,
            icon3:BsHeartPulse,
            title:'Disability, Critical Illness, Accidental Death',
        },
        {
            icon:BsBank,
            title:'Building Wealth'
        },
    ]

    // Initialize Firestore
    const db = getFirestore(app);
    const functions = getFunctions(app);

    // Request form states
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [inquiryType, setInquiryType] = useState("");
    const [message, setMessage] = useState("");
    const [preferredContactMethod, setPreferredContactMethod] = useState("");
    const [submitted, setSubmitted] = useState(false);
    const [turnstileToken, setTurnstileToken] = useState("");
    const [turnstileError, setTurnstileError] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Modal state
    const [modalIsOpen, setModalIsOpen] = useState(false);

    // Prevent scrolling when the modal is open
    useEffect(() => {
        document.body.style.overflow = modalIsOpen ? 'hidden' : 'auto';
    }, [modalIsOpen]);

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Check if Turnstile challenge is completed
        if (!turnstileToken) {
            setTurnstileError("Please complete the security challenge before submitting.");
            return;
        }
        
        setIsSubmitting(true);
        setTurnstileError("");
        
        try {
            // Verify the Turnstile token with Firebase Functions
            const verifyTurnstile = httpsCallable(functions, 'verifyTurnstile');
            const verificationResult = await verifyTurnstile({ token: turnstileToken });
            
            if (!verificationResult.data.success) {
                throw new Error('Turnstile verification failed');
            }
            
            // Proceed with Firebase submission after successful verification
            await addDoc(collection(db, "quote-request-form"), {
                name: name,
                email: email,
                phone: phone,
                "inquiry-type": inquiryType,
                message: message,
                "preferred-contact-method": preferredContactMethod,
                'contact-opt-in': true,
                'turnstile-verified': true,
                timestamp: serverTimestamp()
            });
            
            // Open the modal on successful submission
            setModalIsOpen(true);
            // Reset form fields after submission:
            setName("");
            setEmail("");
            setPhone("");
            setInquiryType("");
            setMessage("");
            setPreferredContactMethod("");
            setTurnstileToken("");
        } catch (error) {
            console.error("Error submitting form: ", error);
            if (error.message.includes('Turnstile') || error.message.includes('verification')) {
                setTurnstileError("Security verification failed. Please try again.");
            } else {
                setTurnstileError("An error occurred while submitting your request. Please try again.");
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    return(
        <>
        <NavbarTwo navClass="defaultscroll sticky" manuClass="navigation-menu nav-right nav-light"/>
        <section id="page-top" className="home-slider position-relative">
            <Carousel className="myCarouselOverride" showArrows={false} selectedItem={0} infiniteLoop={true} autoPlay={true} interval={12000} showStatus={false} animationHandler="fade" transitionTime={5000} swipeable={false} showThumbs={false}>
            <div className="carousel-item active" data-bs-interval="3000">
                        <div className="bg-home carousel-bg-1 d-flex align-items-center" style={{backgroundImage:`url(${bg2})`}}>
                            <div className="bg-overlay bg-linear-gradient"></div>
                            <div className="container">
                                <div className="row justify-content-center">
                                    <div className="col-12">
                                        <div className="title-heading carousel-text-1 text-center">
                                            <h1 className="fw-semibold display-3 text-white title-dark mb-4">Life insurance isn't optional, <br></br>it's essential.</h1>
                                            <p className="para-desc mx-auto text-white"><b>Inclusive. Equitable. Individual. Affordable.</b><br></br>We don’t just have options — we have access to a powerful lineup of A+ rated carriers, giving you top-tier protection backed by the industry's most trusted names.</p>
                                            
                                            <div className="mt-4 pt-2">
                                                <HashLink smooth to="/#request-quote" scroll={scrollWithOffset} className="btn btn-primary btn-quote-custom">Request a Quote</HashLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="carousel-item active" data-bs-interval="3000">
                        <div className="bg-home carousel-bg-2 d-flex align-items-center" style={{backgroundImage:`url(${bg8})`}}>
                            <div className="bg-overlay bg-linear-gradient"></div>
                            <div className="container">
                                <div className="row justify-content-center">
                                    <div className="col-12">
                                        <div className="title-heading carousel-text-2 text-center">
                                            <h1 className="fw-semibold display-3 text-white title-dark mb-4">Mortgage protection:<br></br>Life insurance superpower.</h1>
                                            <p className="para-desc mx-auto text-white">Let life insurance pay off your mortgage and debts. Don't leave that responsibility to your loved ones.</p>
                                            
                                            <div className="mt-4 pt-2">
                                                <HashLink smooth to="/#request-quote" scroll={scrollWithOffset} className="btn btn-primary btn-quote-custom">Request a Quote</HashLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="carousel-item active" data-bs-interval="3000">
                        <div className="bg-home carousel-bg-3 d-flex align-items-center" style={{backgroundImage:`url(${bg6})`}}>
                            <div className="bg-overlay bg-linear-gradient"></div>
                            <div className="container">
                                <div className="row justify-content-center">
                                    <div className="col-12">
                                        <div className="title-heading carousel-text-3 text-center">
                                            <h1 className="fw-semibold display-3 text-white title-dark mb-4">Life insurance is love insurance.<br></br>Secure your love and your legacy.</h1>
                                            <p className="para-desc mx-auto text-white">Tailored insurance solutions built around honoring diversity and financial empowerment for all.</p>
                                            
                                            <div className="mt-4 pt-2">
                                                <HashLink smooth to="/#request-quote" scroll={scrollWithOffset} className="btn btn-primary btn-quote-custom">Request a Quote</HashLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="carousel-item active" data-bs-interval="3000">
                        <div className="bg-home carousel-bg-4 d-flex align-items-center" style={{backgroundImage:`url(${bg5})`}}>
                            <div className="bg-overlay bg-linear-gradient"></div>
                            <div className="container">
                                <div className="row justify-content-center">
                                    <div className="col-12">
                                        <div className="title-heading carousel-text-4 text-center">
                                            <h1 className="fw-semibold display-3 text-white title-dark mb-4">Income replacement.<br></br>Yep, life insurance does that.</h1>
                                            <p className="para-desc mx-auto text-white">Preserve your family's quality of life. Create a plan to replace lost income.</p>
                                            
                                            <div className="mt-4 pt-2">
                                                <HashLink smooth to="/#request-quote" scroll={scrollWithOffset} className="btn btn-primary btn-quote-custom">Request a Quote</HashLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="carousel-item active" data-bs-interval="8000">
                        <div className="bg-home carousel-bg-5 d-flex align-items-center" style={{backgroundImage:`url(${bg7})`}}>
                            <div className="bg-overlay bg-linear-gradient"></div>
                            <div className="container">
                                <div className="container">
                                    <div className="row justify-content-center">
                                        <div className="col-12">
                                            <div className="title-heading carousel-text-5 text-center">
                                                <h1 className="fw-semibold display-3 text-white title-dark mb-4">Protecting families,<br></br>one generation at a time.</h1>
                                                <p className="para-desc mx-auto text-white">Every family deserves an opportunity to create lasting generational wealth.</p>
                                                
                                                <div className="mt-4 pt-2">
                                                    <HashLink smooth to="/#request-quote" scroll={scrollWithOffset} className="btn btn-primary btn-quote-custom">Request a Quote</HashLink>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="carousel-item active" data-bs-interval="3000">
                        <div className="bg-home carousel-bg-6 d-flex align-items-center" style={{backgroundImage:`url(${bg3})`}}>
                            <div className="bg-overlay bg-linear-gradient"></div>
                            <div className="container">
                                <div className="row justify-content-center">
                                    <div className="col-12">
                                        <div className="title-heading carousel-text-6 text-center">
                                            <h1 className="fw-semibold display-3 text-white title-dark mb-4">Financial security starts here.</h1>
                                            <p className="para-desc mx-auto text-white">Securing life insurance when you are young is one of the smartest financial moves you can make.</p>
                                            
                                            <div className="mt-4 pt-2">
                                                <HashLink smooth to="/#request-quote" scroll={scrollWithOffset} className="btn btn-primary btn-quote-custom">Request a Quote</HashLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </Carousel>
        </section>
        
        {/* Insurance Logos Bar */}
        <section 
            className="d-flex align-items-center insurance-logos-bar" 
            style={{
                backgroundColor: '#f5f5f5', 
            }}
        >
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-12">
                        <div className="d-flex justify-content-center align-items-center flex-wrap">
                            <img src={logo1} alt="Insurance Partner" className="mx-3 mb-1 mt-1" style={{height: '40px', objectFit: 'contain'}} />
                            <img src={logo2} alt="Insurance Partner" className="mx-3 mb-1 mt-1" style={{height: '40px', objectFit: 'contain'}} />
                            <img src={logo3} alt="Insurance Partner" className="mx-3 mb-1 mt-1" style={{height: '40px', objectFit: 'contain'}} />
                            {/*<img src={logo4} alt="Insurance Partner" className="mx-3" style={{height: '40px', objectFit: 'contain'}} />*/}
                            <img src={logo5} alt="Insurance Partner" className="mx-3 mb-1 mt-1" style={{height: '40px', objectFit: 'contain'}} />
                            <img src={logo6} alt="Insurance Partner" className="mx-3 mb-1 mt-1" style={{height: '40px', objectFit: 'contain'}} />
                            <img src={logo7} alt="Insurance Partner" className="mx-3 mb-1 mt-1" style={{height: '40px', objectFit: 'contain'}} />
                            {/*<img src={logo8} alt="Insurance Partner" className="mx-3" style={{height: '40px', objectFit: 'contain'}} />*/}
                            <img src={logo9} alt="Insurance Partner" className="mx-3 mb-1 mt-1" style={{height: '40px', objectFit: 'contain'}} />
                            <img src={logo10} alt="Insurance Partner" className="mx-3 mb-1 mt-1" style={{height: '40px', objectFit: 'contain'}} />
                            <img src={logo11} alt="Insurance Partner" className="mx-3 mb-1 mt-1" style={{height: '40px', objectFit: 'contain'}} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
        <div className="justify-content-center" style={{display:"flex", alignItems:"center", flexDirection:"column", paddingTop:"5px"}}>
                    <ul className="list-unstyled align-items-center social-icon social mb-0">
                        <li className="list-inline-item">
                            <a
                            href="https://facebook.com/profile.php?id=61573685685409#"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="rounded"
                            >
                            <FaFacebookF />
                            </a>
                        </li>
                        <li className="list-inline-item">
                            <a
                            href="https://www.instagram.com/dscottsmith_ifi/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="rounded mt-1"
                            >
                            <AiOutlineInstagram />
                            </a>
                        </li>
                        {/*<li className="list-inline-item">
                            <a
                            href="https://youtube.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="rounded mt-1"
                            >
                            <AiOutlineYoutube />
                            </a>
                        </li>*/}
                        <li className="list-inline-item">
                            <a
                            href="https://www.linkedin.com/company/inclusive-family-insurance-group"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="rounded mt-1"
                            >
                            <AiFillLinkedin />
                            </a>
                        </li>
                        <li className="list-inline-item">
                            <a
                            href="https://bsky.app/profile/inclusive-fam-ins.bsky.social"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="rounded mt-1"
                            >
                            <AiFillBluesky />
                            </a>
                        </li>
                    </ul>
                </div>
            <section className="section" style={{ paddingTop: "5px" }}>
            <div className="container" style={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
                <div className="col-lg-7 col-md-6 order-2 order-md-1" style={{ width: "85%", paddingLeft: "20px", paddingRight: "20px" }}>
                <div className="row">
                    <div style={{
            maxWidth: '1000px',
            margin: '40px auto'
            }}>
            <img
                src={headshot}
                alt="Picture of David Scott Smith, Founder of Inclusive Family Insurance"
                className="headshot-responsive"
            />
                <h4 style={{ marginTop: '0px', marginBottom: '12px' }}>Inclusive Family Insurance Group</h4>
                <p className="text-muted2" style={{ marginTop: 0 }}><b>Meet David (Scott) Smith,</b> <br></br>Independent Insurance Broker | Husband | Father | Advocate for Individuals and Families</p>
                <p className="text-muted2" style={{ marginTop: 0 }}>
                With 30 years of real-world experience navigating every aspect of life and family life, I’ve made it my mission to help people living through all kinds of personal and financial realities find the tools that create lasting protection, peace of mind, and long-term financial security. Whether you're just starting a family, buying your first home, or preparing for the next chapter, I’m here to walk that road with you - honestly, personally, and with your goals at the center of our work together.
                </p>
                <p className="text-muted2" style={{ marginTop: 0 }}>
                <b>49% of US Adults don't have life insurance of any kind.</b> We believe the protections that life and disability insurance can provide should never be limited by race, income, sexual orientation, gender identity, or circumstance. We're redefining what it means to serve an "entire community" by breaking down systemic barriers and building a business model where equity, dignity, and access come first.  
                <br />
                </p>
                <p className="text-muted2" style={{ marginTop: 0 }}>
                <u><b>We work for you,</b></u> not the insurance carrier.
                </p>
                <p className="text-muted2" style={{ marginBottom: '8px', marginTop: 0 }}>Our approach:</p>
                <ul className="text-muted2" style={{ marginTop: 0, marginBottom: '12px', paddingLeft: '20px' }}>
                <li>Listen first</li>
                <li>Understand your needs along with who/what you want to protect</li>
                <li>Then we will aggressively seek out the best policies and rates that the A+ rated carriers we work with have to offer.</li>
                </ul>
                <p className="text-muted2" style={{ marginTop: 0 }}>
                <u><b>No sales pressure. Ever.</b></u>
                <br />
                Just information you can trust as you seek to make important decisions that benefit your family and loved ones.
                </p>
                <p className="text-muted2" style={{ marginTop: 0 }}>
                The Inclusive Family Insurance Group is an independent insurance brokerage that <u><b>works for you.</b>+++</u>  We are a proud affiliate of Symmetry Financial Group, who at the end of 2024 had surpassed their goal of assisting over 1 million families secure and protect their future.
                </p>
            </div>

                {/* Card rendering section */}
                <div className="row" style={{ marginTop: '-20px' }}>
                    {aboutData.map((item, index) => {
                    if (item.icon2 && item.icon3) {
                        return (
                        <div className="col-lg-6 col-12 mb-4 pt-2" key={index}>
                            <div className="card features feature-primary">
                            <div className="d-flex align-items-center">
                                <item.icon className="icon h1 mb-3" />
                                <item.icon2 className="icon h1 ms-3 mb-3" />
                                <item.icon3 className="icon h1 ms-3 mb-3" />
                            </div>
                            <div>
                                <h5 className="text-dark d-block">
                                {item.title}
                                </h5>
                            </div>
                            <Checkmarks sectionId={index} />
                            </div>
                        </div>
                        );
                    } else {
                        const Icon = item.icon;
                        return (
                        <div className="col-lg-6 col-12 mb-4 pt-2" key={index}>
                            <div className="card features feature-primary">
                            <Icon className="icon h1 d-block mb-3" />
                            <h5 className="text-dark">
                                {item.title}
                            </h5>
                            <Checkmarks sectionId={index} />
                            </div>
                        </div>
                        );
                    }
                    })}
                </div>
                </div>
            </div></div>
            </section>
        
        <section className="position-relative overflow-hidden w-100">
        <Parallax
                blur={{ min: 0, max: 0}}
                bgImage={bg4}
                bgImageAlt="mom with daughter"
                strength={500}
                bgportfolioImgize="100%"
                bgStyle={{with:"auto", height:"100%" }}
                style={{position:"absolute", width:"100%" , height:"100%"}}
            />
            <div className="bg-half-170">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                           
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section id="request-quote" className="section">
        <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 mb-4 pb-2">
                        <div className="section-title text-center">
                            <h6 className="text-primary">Request a Quote</h6>
                            <h4 className="title fw-semibold mt-2 mb-3">Secure Your Future! <br></br>Insurance policies tailored to meet YOUR needs.</h4>
                            <p className="text-muted2 para-desc mx-auto mb-0">Fill out the form below to request a personalized quote or hit us up with any questions you may have.  We are here to help!</p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-8 col-md-10 col-12 mx-auto">
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="form-label">
                                    Full Name <span className="text-danger">*</span>
                                    </label>
                                    <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Your Name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    required
                                    />
                                </div>
                                </div>
                                <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="form-label">
                                    Email <span className="text-danger">*</span>
                                    </label>
                                    <input
                                    type="email"
                                    className="form-control"
                                    placeholder="Your Email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    />
                                </div>
                                </div>
                                <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="form-label">
                                    Phone Number <span className="text-danger">*</span>
                                    </label>
                                    <input
                                    type="tel"
                                    className="form-control"
                                    placeholder="Your Phone Number"
                                    value={phone}
                                    onChange={(e) => setPhone(e.target.value)}
                                    required
                                    />
                                </div>
                                </div>
                                <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="form-label">
                                    Preferred Contact Method <span className="text-danger">*</span>
                                    </label>
                                    <select
                                    className="form-select"
                                    value={preferredContactMethod}
                                    onChange={(e) => setPreferredContactMethod(e.target.value)}
                                    required
                                    >
                                    <option value="" disabled>
                                        -- Select One --
                                    </option>
                                    <option value="phone">Phone</option>
                                    <option value="email">Email</option>
                                    </select>
                                </div>
                                </div>
                                <div className="col-md-12">
                                <div className="mb-3">
                                    <label className="form-label">
                                    Inquiry Type <span className="text-danger">*</span>
                                    </label>
                                    <select
                                    className="form-select"
                                    value={inquiryType}
                                    onChange={(e) => setInquiryType(e.target.value)}
                                    required
                                    >
                                    <option value="" disabled>
                                        -- Select One --
                                    </option>
                                    <option value="Life Insurance">Life Insurance</option>
                                    <option value="Disability Care">Supplemental Insurance</option>
                                    <option value="General Inquiry">I'm not sure, but I have a few questions.</option>
                                    </select>
                                </div>
                                </div>
                                <div className="col-12">
                                <div className="mb-3">
                                    <label className="form-label">Message</label>
                                    <textarea
                                    className="form-control"
                                    rows="4"
                                    placeholder="Tell us a little more about who and what you are trying to protect.  We would love to help."
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    ></textarea>
                                </div>
                                </div>
                            </div>
                            
                            <button 
                                type="submit" 
                                className="btn btn-primary mb-3 btn-quote-custom"
                                disabled={isSubmitting || !turnstileToken}
                            >
                                {isSubmitting ? "Submitting..." : "Send Request"}
                            </button>
                            
                            {/* Cloudflare Turnstile Widget */}
                            <div className="mb-3">
                                <Turnstile
                                    siteKey={process.env.REACT_APP_TURNSTILE_SITE_KEY || "0x4AAAAAABmkVRfDoLLQkv0d"}
                                    onSuccess={(token) => {
                                        setTurnstileToken(token);
                                        setTurnstileError("");
                                    }}
                                    onError={() => {
                                        setTurnstileError("Security verification failed. Please try again.");
                                        setTurnstileToken("");
                                    }}
                                    onExpire={() => {
                                        setTurnstileError("Security verification expired. Please complete the challenge again.");
                                        setTurnstileToken("");
                                    }}
                                    options={{
                                        theme: 'light',
                                        size: 'normal',
                                    }}
                                />
                                {turnstileError && (
                                    <div className="text-danger mt-2 small">
                                        {turnstileError}
                                    </div>
                                )}
                            </div>
                        </form>
                        <div style={{display:"flex", alignItems:"center", flexDirection:"column"}}>
                        <p className="text-muted small mt-3">By submitting this form, you agree to be contacted by David Scott Smith, an independent insurance broker (licensed in VA, NC, SC, TN, and GA) and affiliate of Symmetry Financial Group. You may be contacted by phone, text message, or email at the number and/or email address you provide, even if your number is on a state or federal Do Not Call list. Message and data rates may apply. You may opt out at any time.</p>
                        </div>
                        {submitted && (
                            <p className="mt-3 text-success">
                                Thank you! Your request has been submitted successfully.
                            </p>
                        )}
                    </div>
                </div>
            </div>
            
        </section>
        {/* Modal for form submission success */}
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={() => setModalIsOpen(false)}
            contentLabel="Submission Success"
            overlayClassName={{
                base: 'ReactModal__Overlay quote-request-modal__overlay',
                afterOpen: 'ReactModal__Overlay--after-open quote-request-modal__overlay--after-open',
                beforeClose: 'ReactModal__Overlay--before-close quote-request-modal__overlay--before-close',
            }}
            style= {{
                content: {
                    maxWidth: "500px",
                    maxHeight: "200px",
                    margin: "auto",
                    padding: "20px",
                    textAlign: "center",
                    zIndex: 1002, // content above the overlay
                },
            }}
        >
            <h2>Success!</h2>
            <p>Thank you. Your message to us has been submitted successfully. We will respond within one business day.</p>
            <button className="btn btn-primary" onClick={() => setModalIsOpen(false)}>
            Close
            </button>
        </Modal>
        <FloatingTextBubble
            bottom={100}
            right={30}
            text="Curious about how much insurance you need?"
            linkReportText="Get your instant report here"
            linkReportHref="/financial-security-calculator"
            linkCalendarText="Schedule a call with me"
            linkCalendarHref="/calendly"
        />
        <FooterThree/>
        <ScrollTop/>
        </>
    )
}